import { useEffect } from 'react'

import { CountryCode } from '@common'
import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query'
import isBot from 'isbot'

import { useFetchMarketQuery } from '../../api'
import { useModalContext } from '../../contexts/ModalContext'
import { getCookie, VIEWER_COUNTRY } from '../../utils/cookies'
import { useAppDispatch } from '../../utils/useAppDispatch'
import { useAppSelector } from '../../utils/useAppSelector'
import { setViewerCountry } from '../locale/configSlice'

const is400 = (err: FetchBaseQueryError | SerializedError | undefined) => {
  if (err && 'status' in err) {
    return err.status === 400
  }
  return false
}

export function useResolveViewerCountry() {
  const viewerCountry = useAppSelector((state) => state.config.viewerCountry)
  const { openModal } = useModalContext()
  const dispatch = useAppDispatch()
  const { data: market, isSuccess, error } = useFetchMarketQuery(viewerCountry ?? skipToken)
  useEffect(() => {
    if (!viewerCountry) {
      const viewerCountryFromCookie = getCookie(VIEWER_COUNTRY) as CountryCode | null
      if (viewerCountryFromCookie) {
        dispatch(setViewerCountry(viewerCountryFromCookie))
      } else {
        openModal({ type: 'UNAVAILABLE' })
      }
      return
    }
  }, [viewerCountry, dispatch, openModal])

  useEffect(() => {
    if (is400(error) && !isBot(navigator.userAgent)) {
      openModal({ type: 'UNAVAILABLE' })
    }
  }, [isSuccess, market, error, openModal])
}
